module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular-Italic.4373843c.woff";